import { http } from './http';

const SESSION_KEY = 'simimovies.visitor.session.v1';

function getSessionId() {
  try {
    let id = window.localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return '';
  }
}

export function trackPageView({ path, pageType, category, tmdbId, language } = {}) {
  if (typeof window === 'undefined') return Promise.resolve();
  const payload = {
    path: path || window.location.pathname,
    pageType: pageType || '',
    category: category || '',
    tmdbId: tmdbId != null ? Number(tmdbId) : null,
    language: language || '',
    sessionId: getSessionId(),
    referrer: document.referrer || '',
  };
  return http.post('/api/v1/visitors/track', payload).catch(() => null);
}
